/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { styled } from 'styled-components';

import { createResponsiveSpacingStyle } from '../../../utils';
import type { ResponsiveSpacing } from '../../../utils/types';

type VerticalSpacerProps = {
  marginBottom: ResponsiveSpacing;
  children?: React.ReactNode | null;
};

const Wrapper = styled.div<VerticalSpacerProps>`
  ${props => props.marginBottom && `${createResponsiveSpacingStyle('margin-bottom', props.marginBottom)}`};
`;

export const VerticalSpacer = ({ marginBottom, children }: VerticalSpacerProps) => (
  <Wrapper marginBottom={marginBottom}>{children}</Wrapper>
);
